var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"upload-preview-readPretty"},_vm._l((_vm.values),function(item,index){return _c('div',{key:index,staticClass:"img-item",on:{"click":function($event){return _vm.showPicture(index)}}},[_c('img',{attrs:{"src":item}})])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }